import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HelpSearchService } from '../services/help-search.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-help-header',
  imports: [CommonModule, FormsModule],
  templateUrl: './help-header.component.html',
  styleUrl: './help-header.component.scss'
})
export class HelpHeaderComponent {


  searchText = '';
  constructor(private router: Router,private helpSearchService: HelpSearchService) {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
        const text = this.helpSearchService.searchText$.value;
        if (!text) {
          return;
        }
        setTimeout(() => {
          this.highlightText(text);
        }, 300);
      });
  }
  onSearch(): void {
    this.helpSearchService.searchText$.next(this.searchText);
    this.highlightText(this.searchText);
  }

  clearSearch(): void {
    this.searchText = '';
    this.helpSearchService.searchText$.next('');
    this.removeHighlights();
  }


  private removeHighlights(): void {

    document
      .querySelectorAll('.highlight-help')
      .forEach(mark => {

        const parent = mark.parentNode;

        if (!parent) {
          return;
        }

        parent.replaceChild(
          document.createTextNode(mark.textContent || ''),
          mark
        );

        parent.normalize();
      });
  }

  private highlightText(searchTerm: string): void {

    this.removeHighlights();

    if (!searchTerm.trim()) {
      return;
    }

    const container = document.querySelector('.help-content');

    if (!container) {
      return;
    }

    const regex = new RegExp(
      searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
      'gi'
    );

    const walker = document.createTreeWalker(
      container,
      NodeFilter.SHOW_TEXT
    );

    const textNodes: Text[] = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode as Text);
    }

    textNodes.forEach(node => {

      const text = node.nodeValue ?? '';

      if (!text.match(regex)) {
        return;
      }

      regex.lastIndex = 0;

      const wrapper = document.createElement('span');

      wrapper.innerHTML = text.replace(
        regex,
        '<mark class="highlight-help">$&</mark>'
      );

      node.parentNode?.replaceChild(
        wrapper,
        node
      );
    });
  }

}
